import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Container, Grid, Image, Label, Segment } from 'semantic-ui-react'

import back from '../../assets/images/angle-fuchsia.png'
import { isUrl } from '../../helpers/chisels'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import { format } from '../../helpers/timezones'

class ParticipantJournal extends Component {
    constructor (props) {
        super(props)
        this.state = {
            journal: undefined
        }
        autoBind(this)
    }

    componentDidMount () {
        if (this.props.userTokens.accessToken.token && this.props.item) {
            // Fetch the journal.
            this.fetchJournal(this.props.item)
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.userTokens.accessToken.token !== this.props.userTokens.accessToken.token || nextProps.item !== this.props.item) {
            // Fetch the journal.
            this.fetchJournal(this.props.item)
        }
    }

    // Fetches the participant's journal with the given ID.
    fetchJournal (id) {
        // eslint-disable-next-line no-console
        console.log('Fetch journal.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/patients/${this.props.match.params.id}/journals/${id}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched journal.')
                this.setState({ journal: response.data })
            })
            .catch((error) => {
                // Failed to fetch journal.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch journal.', error)
                // Hide the error.
                this.setState({ journal: undefined })
            })
    }

    render () {
        if (!this.state.journal) {
            return null
        }
        let gradient = null
        let feeling = this.state.journal.Feeling
        switch (feeling) {
            case tr('HAPPY'):
                feeling = 'Joyous'
                gradient = 'linear-gradient(90deg, rgba(33, 215, 200, 1.0) #p1#, #ffffff #p2#)'
                break
            case tr('ANGRY'):
                feeling = 'Distressed'
                gradient = 'linear-gradient(90deg, rgba(50, 34, 129, 1.0) #p1#, #ffffff #p2#)'
                break
            case tr('CALM'):
                feeling = 'Content'
                gradient = 'linear-gradient(90deg, rgba(171, 214, 226, 1.0) #p1#, #ffffff #p2#)'
                break
            case tr('SAD'):
                feeling = 'Sad'
                gradient = 'linear-gradient(90deg, rgba(37, 41, 69, 1.0) #p1#, #ffffff #p2#)'
                break
            default:
                // This is not possible, but let's be sad by default.
                gradient = 'linear-gradient(90deg, rgba(37, 41, 69, 1.0) #p1#, #ffffff #p2#)'
                break
        }
        if (this.state.journal.Intensity === '0') {
            gradient = gradient.replace('#p1#', 0 + '%')
            gradient = gradient.replace('#p2#', 0 + '%')
        } else if ((this.state.journal.Intensity === '10')) {
            gradient = gradient.replace('#p1#', 100 + '%')
            gradient = gradient.replace('#p2#', 100 + '%')
        } else {
            gradient = gradient.replace('#p1#', this.state.journal.Intensity * 10 - 10 + '%')
            gradient = gradient.replace('#p2#', this.state.journal.Intensity * 10 + '%')
        }
        return (
            <Container className={`participant-journal ${feeling.toLowerCase()}`}>
                <Segment
                    className='navigation-item'
                    onClick={(_e) => { this.props.onCloseItem() }}
                >
                    <Image src={back}/>
                    {format(this.state.journal.created, 'dddd, MMMM D, YYYY @HH:mm', this.props.timezone, this.props.language)}
                </Segment>
                <div className='l4'>
                    <Segment className='emotion-tags'>
                        <Segment className='emotion'>{this.state.journal.Feeling}</Segment>
                        <Segment className='tags'>
                            {
                                /* eslint-disable react/no-array-index-key */
                                this.state.journal.Tags.map((tag, index) => {
                                    return (
                                        <Label key={`tag${index}`} className='emotional-tag'>{tag}</Label>
                                    )
                                })
                                /* eslint-enable react/no-array-index-key */
                            }
                        </Segment>
                    </Segment>
                    <Segment className='intensity-rating'>
                        <Segment className='title'>{tr('INTENSITY_RATING')}</Segment>
                        <Segment
                            className='text'>{this.state.journal.Intensity || 0}&nbsp;{tr('OUT_OF')}&nbsp;10</Segment>
                        <Segment className='scale' style={{ 'backgroundImage': gradient }}/>
                    </Segment>
                    <Segment className='words'>
                        <Segment className='title'>{tr('YOUR_WORDS')}</Segment>
                        <Segment>
                            <Grid>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <Segment className='title'>{tr('EVENT')}</Segment>
                                        <Segment className='text'>
                                            {
                                                /* eslint-disable jsx-a11y/media-has-caption */
                                                isUrl(this.state.journal.Events) ? (
                                                    <audio controls controlsList='nodownload'>
                                                        <source src={this.state.journal.Events}/>
                                                    </audio>
                                                ) : (
                                                    <span>{this.state.journal.Events}</span>
                                                )
                                                /* eslint-enable jsx-a11y/media-has-caption */
                                            }
                                        </Segment>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Segment className='title'>{tr('THOUGHTS')}</Segment>
                                        <Segment className='text'>
                                            {
                                                /* eslint-disable jsx-a11y/media-has-caption */
                                                isUrl(this.state.journal.Thoughts) ? (
                                                    <audio controls controlsList='nodownload'>
                                                        <source src={this.state.journal.Thoughts}/>
                                                    </audio>
                                                ) : (
                                                    <span>{this.state.journal.Thoughts}</span>
                                                )
                                                /* eslint-enable jsx-a11y/media-has-caption */
                                            }
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <Segment className='title'>{tr('BEHAVIOUR')}</Segment>
                                        <Segment className='text'>
                                            {
                                                /* eslint-disable jsx-a11y/media-has-caption */
                                                isUrl(this.state.journal.Behaviours) ? (
                                                    <audio controls controlsList='nodownload'>
                                                        <source src={this.state.journal.Behaviours}/>
                                                    </audio>
                                                ) : (
                                                    <span>{this.state.journal.Behaviours}</span>
                                                )
                                                /* eslint-enable jsx-a11y/media-has-caption */
                                            }
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Segment>
                    </Segment>
                    {
                        ['Sad', 'Distressed'].indexOf(feeling) >= 0 && (
                            <React.Fragment>
                                <Segment className='cognitive-distortions'>
                                    <Segment className='title'>{tr('COGNITIVE_DISTORTIONS')}</Segment>
                                    <Segment className='distortions'>
                                        {
                                            /* eslint-disable react/no-array-index-key */
                                            (this.state.journal.CognitiveDistortions || []).map((distortion, index) => {
                                                return (
                                                    <Label key={`distortion${index}`}
                                                        className='cognitive-distortion'>{distortion}</Label>
                                                )
                                            })
                                            /* eslint-enable react/no-array-index-key */
                                        }
                                    </Segment>
                                </Segment>
                                <Segment className='bodily-sensations'>
                                    <Segment className='title'>{tr('PHYSICAL_SENSATIONS')}</Segment>
                                    <Segment className='sensations'>
                                        {
                                            /* eslint-disable react/no-array-index-key */
                                            (this.state.journal.BodilySensations || []).map((sensation, index) => {
                                                return (
                                                    <Label key={`sensation${index}`}
                                                        className='bodily-sensation'>{sensation}</Label>
                                                )
                                            })
                                            /* eslint-enable react/no-array-index-key */
                                        }
                                    </Segment>
                                </Segment>
                            </React.Fragment>
                        )
                    }
                </div>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        item: state.participants.location.item,
        language: state.settings.language,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (_dispatch) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ParticipantJournal))



// WEBPACK FOOTER //
// ./src/components/participant-journal/index.js